import { Helmet } from "react-helmet";
import {
    Box,
    MenuItem,
    Select,
    Container,
    Grid,
    Typography,
    Button,
    Collapse,
    FormHelperText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo } from "react";
import { ReactComponent as PlusGreen } from "../../../../assets/icons/plusGreen.svg";
import { ReactComponent as Avatar } from "../../../../assets/icons/avatar.svg";
import { ReactComponent as EyeMapping } from "../../../../assets/icons/eyeMapping.svg";
import { ReactComponent as Trash } from "../../../../assets/icons/trash.svg";
import emty from "../../../../assets/images/emty.png";
import DialogSubTitle from "../../../../components/DialogSubTitle";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import * as Util from "../../../../services/global.service";
import { ReactComponent as ExpandDown } from "../../../../assets/icons/expandDown.svg";
import { ReactComponent as ExpandUp } from "../../../../assets/icons/expandUp.svg";
import { useFormik } from 'formik';
import competencyMapping from "../../../../services/competencyMapping.service";
import AddCompetency from "./AddCompetency";

const useStyles = makeStyles({
    disabled: {
        backgroundColor: "#FAFAFA !important",
        '& .Mui-disabled': {
            '-webkit-text-fill-color': '#404349 !important',
            backgroundColor: "#FAFAFA !important"
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: "none"
        }
    },
    grayedAddSvg: {
        '& path': {
            fill: '#A0A0A0 !important',
            stroke: '#A0A0A0 !important'
        },
        '& g > path': {
            fill: '#A0A0A0 !important',
            stroke: '#A0A0A0 !important'
        },
    }
});
const styles = {
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
};

const Cycle = () => {
    let { type, cycle_id, serial } = useParams()

    const [itemsCompetency, setItemsCompetency] = React.useState([]);
    const [target, setTarget] = React.useState([]);
    const [itemsAdd, setItemsAdd] = React.useState({});
    const [itemsDel, setItemsDel] = React.useState({});
    const [open, setOpen] = React.useState(false);
    const [canEdit, setCanEdit] = React.useState(true);
    const [firstChange, setFirstChange] = React.useState(false);
    const [submit, setSubmit] = React.useState(false);
    const classes = useStyles();
    const { t } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {

    }, []);

    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: cycle_id } });
    }
    const [isConfirmOpen, openConfirm] = React.useState(false);
    const handleConfirm = (val) => {
        openConfirm(val);
    };
    const handleConfirmChange = () => {
        openConfirm(false)
        clickLink('/admin/competency-mapping')
    };
    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const handleConfirmDeleteDialog = (val, serial, competency_mapping_data, index, id) => {
        let data = {
            serial: Util.formatData(serial, ""),
            competency_mapping_data: Util.formatData(competency_mapping_data, {}),
            index: Util.formatData(index, ""),
            id: Util.formatData(id, "")
        }
        setItemsDel(data)
        openConfirmDeleteDialog(val);
    };
    const handleConfirmDeleteList = () => {
        if (firstChange === false) {
            setFirstChange(true)
        }
        delData(itemsDel?.serial, itemsDel?.competency_mapping_data, itemsDel?.index, itemsDel?.id, itemsCompetency)
        openConfirmDeleteDialog(false)
    };

    const [itemsOpen, setItemsOpen] = React.useState([
    ]);
    let onChangeOpen = (data) => {
        let findData = itemsOpen.filter((rs) => rs === data)
        if (findData.length === 0) {
            setItemsOpen([...itemsOpen, data])
        } else {
            let newData = []
            for (let index = 0; index <= itemsOpen.length - 1; index++) {
                if (itemsOpen[index] !== data) {
                    newData.push(itemsOpen[index])
                }
            }
            setItemsOpen(newData)
        }
    }

    const formik = useFormik({
        initialValues: {
            competency_mapping_data: {},
        },
        enableReinitialize: true,
        // validationSchema: ""
        onSubmit: (values) => {
            setSubmit(true)
            if (checkAllValidate() === false) {
                let newData = {
                    cycle_id: cycle_id,
                    competency_mapping_data: [
                    ],
                    options: {}
                }
                for (let index = 0; index <= Object.keys(values?.competency_mapping_data).length - 1; index++) {
                    newData.competency_mapping_data.push(values?.competency_mapping_data[Object.keys(values?.competency_mapping_data)[index]])
                }
                competencyMapping.saveCompetencyMapping(type, serial, newData).then(
                    (response) => {
                        setFirstChange(false)
                        openSuccessDeleteDialog(true)
                    },
                ).catch(() => {
                })
            } else {
                console.log('Validated')
            }
        },
    });

    let saveSuccess = () => {
        openSuccessDeleteDialog(false)
        clickLink('/admin/competency-mapping')
    }
    useEffect(() => {
        competencyMapping.getCompetencyMapping(type, cycle_id, serial).then((rs) => {
            let newData = []
            let setData = {}
            let data = Util.formatData(rs?.data?.competency_mapping, false) !== false ? rs?.data?.competency_mapping : []
            setItemsCompetency(data);
            setCanEdit(Util.formatData(rs?.data?.cycle?.options?.allow_adjust, false))
            setTarget(Util.formatData(rs?.data?.target, false) !== false ? rs?.data?.target : [])
            for (let index = 0; index <= data.length - 1; index++) {
                newData.push(data[index]?.serial)
                if (Util.formatData(data[index]?.competencies, false) !== false && data[index]?.competencies.length > 0) {
                    let competencies = data[index]?.competencies
                    for (let id = 0; id <= competencies.length - 1; id++) {
                        setData[competencies[id].serial] = {}
                        if (Util.formatData(competencies[id]?.proficiency, false) !== false && competencies[id]?.proficiency.length > 0) {
                            let filterData = competencies[id].proficiency.filter((rs) => rs?.is_default === true)
                            if (filterData.length > 0) {
                                setData[competencies[id].serial].competency_id = competencies[id].serial
                                setData[competencies[id].serial].proficiency_id = filterData[0].serial
                            } else {
                                setData[competencies[id].serial].competency_id = competencies[id].serial
                                setData[competencies[id].serial].proficiency_id = ""
                            }
                        }
                        if (Util.formatData(competencies[id]?.competency_scale, false) !== false && competencies[id]?.competency_scale.length > 0) {
                            let filterData = competencies[id].competency_scale.filter((rs) => rs?.is_default === true)
                            if (filterData.length > 0) {
                                setData[competencies[id].serial].competency_id = competencies[id].serial
                                setData[competencies[id].serial].expected_rating = filterData[0].serial
                            } else {
                                setData[competencies[id].serial].competency_id = competencies[id].serial
                                setData[competencies[id].serial].expected_rating = ""
                            }
                        }
                    }
                }
            }
            formik.setFieldValue("competency_mapping_data", setData)
            setItemsOpen(newData)
        }).catch((err) => {

        })

    }, []);
    let getAdd = () => {
        competencyMapping.getAddCompetencyMapping(type, cycle_id, serial).then((rs) => {
            setItemsAdd(rs?.data)
        }).catch((err) => {

        })
    }

    let openAdd = () => {
        getAdd()
        setOpen(true)
    }
    let selectValuse = (data, item, values, field) => {
        if (firstChange === false) {
            setFirstChange(true)
        }
        let newData = JSON.parse(JSON.stringify(values))
        newData[data] = { ...newData[data] }
        newData[data].competency_id = data
        if ("proficiency_id" && newData[data][field] !== item) {
            newData[data].expected_rating = ""
        }
        newData[data][field] = item
        formik.setFieldValue("competency_mapping_data", newData)
    }

    let nextData = (data, newData) => {
        if (firstChange === false) {
            setFirstChange(true)
        }
        setItemsCompetency(data)
        let formikData = JSON.parse(JSON.stringify(formik.values.competency_mapping_data))
        let open = []
        for (let index = 0; index <= data.length - 1; index++) {
            open.push(data[index]?.serial)
        }
        for (let index = 0; index <= Object.keys(formikData).length - 1; index++) {
            let filterData = newData.filter((rs) => rs === Object.keys(formikData)[index])
            if (filterData.length === 0) {
                delete formikData[Object.keys(formikData)[index]]
            }
        }
        formik.setFieldValue("competency_mapping_data", formikData)
        setOpen(false)
        setItemsOpen(open)
    }

    let delData = (data, values, index, id, listItemsCompetency) => {
        let newData = JSON.parse(JSON.stringify(values))
        let item = listItemsCompetency
        item[index].competencies.splice(id, 1)
        if (item[index].competencies.length === 0) {
            item.splice(index, 1)
        }
        delete newData[data]
        console.log(newData, 99);
        setItemsCompetency(item)
        formik.setFieldValue("competency_mapping_data", newData)
    }

    let checkAllValidate = () => {
        let formikData = JSON.parse(JSON.stringify(formik.values.competency_mapping_data))
        let check = false
        for (let index = 0; index <= itemsCompetency.length - 1; index++) {
            if (check === false) {
                for (let id = 0; id <= itemsCompetency[index].competencies.length - 1; id++) {
                    if (check === false) {
                        let data = itemsCompetency[index].competencies[id]
                        if (data?.have_proficiency === true && Util.formatData(data?.proficiency, false) !== false && data?.proficiency.length > 0) {
                            if (Util.formatData(formikData[itemsCompetency[index].competencies[id]?.serial]?.proficiency_id, false) === false) {
                                check = true
                            }
                        }
                        if (Util.formatData(formikData[itemsCompetency[index].competencies[id]?.serial]?.expected_rating, false) === false) {
                            check = true
                        }
                    }
                }
            }
        }
        return check
    }
    const openNewTab = (val) => {
        const newWindow = window.open(val, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }
    let getName = (data) => {
        let dataMain = data.toLowerCase()
        let index = dataMain.search("<br")
        if (Util.formatData(data, false) !== false) {
            if (index >= 0) {
                return data.substr(0, index)
            } else {
                return data
            }
        }
        return ""
    }
    return (
        <Box style={{ "maxHeight": "100%", "overflowY": "auto" }}>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/competency-mapping')}>{t('sidebar.label.competencyMapping')}</span> / <span style={styles.end} >{t('competencyMapping.manageCompetencyMapping')}</span></Typography>
                    </Grid>
                    <Grid container item >
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} pt="7px">
                            <Typography variant="h2" color="#404349" fontSize={36} lineHeight="40px" >
                                {t('competencyMapping.manageCompetencyMapping')}
                            </Typography>
                            <Button onClick={() => { openNewTab("/admin/current-employees/" + serial + "/" + type + "/" + cycle_id) }} sx={{ display: "flex", height: "45px", "text-transform": "none" }} variant="dashed-solid" >
                                <Box sx={{ display: "flex", "align-items": "center" }}>
                                    <Avatar /><Typography ml="8px" fontSize={18} lineHeight="26.91px" fontWeight="500" color="#404349">{t('admin.label.currentEmployees')}</Typography>
                                </Box>
                            </Button>

                        </Box>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid container item >
                            <Box mt="30px" p="40px" sx={{ width: "100%", background: "#FFFFFF", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", borderRadius: "10px" }}>
                                {type === "job" ?
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <Typography width="92px" color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                            {t('admin.inputForm.jobCode')}
                                        </Typography>
                                        <Typography pl="23px" color="#AAAAAA" fontSize={18} lineHeight="26.91px" fontWeight="400" >
                                            {target?.code} {Util.formatData(target?.code, false) !== false && Util.formatData(target?.name, false) !== false ? "-" : ""} {target?.name}
                                        </Typography>
                                    </Box>
                                    : type === "position" ?
                                        <Box>
                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                <Typography width="92px" color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                                    {t('label.positions')}
                                                </Typography>
                                                <Typography pl="23px" color="#AAAAAA" fontSize={18} lineHeight="26.91px" fontWeight="400" >
                                                    {target?.code} {Util.formatData(target?.code, false) !== false && Util.formatData(target?.name, false) !== false ? "-" : ""} {target?.name}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                <Typography width="92px" color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                                    {t('label.team')}
                                                </Typography>
                                                <Typography pl="23px" color="#AAAAAA" fontSize={18} lineHeight="26.91px" fontWeight="400" >
                                                    {target?.options?.organization?.code} {Util.formatData(target?.options?.organization?.code, false) !== false && Util.formatData(target?.options?.organization?.name, false) !== false ? "-" : ""} {target?.options?.organization?.name}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        : type === "employee" ?
                                            <Box>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <Typography width="92px" color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                                        {t('label.employee')}
                                                    </Typography>
                                                    <Typography pl="23px" color="#AAAAAA" fontSize={18} lineHeight="26.91px" fontWeight="400" >
                                                        {target?.code} {Util.formatData(target?.code, false) !== false && Util.formatData(target?.name, false) !== false ? "-" : ""} {target?.name}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <Typography width="92px" color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                                        {t('label.positions')}
                                                    </Typography>
                                                    <Typography pl="23px" color="#AAAAAA" fontSize={18} lineHeight="26.91px" fontWeight="400" >
                                                        {target?.options?.posisition?.code} {Util.formatData(target?.options?.posisition?.code, false) !== false && Util.formatData(target?.options?.posisition?.name, false) !== false ? "-" : ""} {target?.options?.posisition?.name}
                                                    </Typography>
                                                </Box>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <Typography width="92px" color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                                        {t('label.team')}
                                                    </Typography>
                                                    <Typography pl="23px" color="#AAAAAA" fontSize={18} lineHeight="26.91px" fontWeight="400" >
                                                        {target?.options?.organization?.code} {Util.formatData(target?.options?.organization?.code, false) !== false && Util.formatData(target?.options?.organization?.name, false) !== false ? "-" : ""} {target?.options?.organization?.name}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            : type === "empgroup" ?
                                                <Box>
                                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                                        <Typography color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                                            {t('label.employeeGroup')}
                                                        </Typography>
                                                        <Typography pl="23px" color="#AAAAAA" fontSize={18} lineHeight="26.91px" fontWeight="400" >
                                                            {target?.code} {Util.formatData(target?.code, false) !== false && Util.formatData(target?.name, false) !== false ? "-" : ""} {target?.name}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                                : type === "empsubgroup" ?
                                                    <Box>
                                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                                            <Typography color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                                                {t('admin.inputForm.employeeSubGroup')}
                                                            </Typography>
                                                            <Typography pl="23px" color="#AAAAAA" fontSize={18} lineHeight="26.91px" fontWeight="400" >
                                                                {target?.code} {Util.formatData(target?.code, false) !== false && Util.formatData(target?.name, false) !== false ? "-" : ""} {target?.name}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    :
                                                    null
                                }
                                <Box pt="25px" pb="10px" >
                                    <Typography color="#404349" fontSize={18} lineHeight="26.91px" fontWeight="500" >
                                        {t('competency.name')} <span style={{ color: "#CC6058" }}>*</span>
                                    </Typography>
                                </Box>
                                <Box px="30px" pt="17px" pb="23px" sx={{ background: "#FFFFFF", border: " 1px solid #CED4DA", borderRadius: "4px" }}>
                                    <Box pb="17px" sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <Box>
                                            <Typography color="#404349" fontSize={16} lineHeight="23.92px" fontWeight="500" >
                                                {t('competencyMapping.selectCompetency')}
                                            </Typography>
                                        </Box>
                                        <Button sx={{ display: "flex", height: "35px", "text-transform": "none", border: "none" }} onClick={canEdit === true ? openAdd : null} disabled={!canEdit} variant="dashed-solid" >
                                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                                <PlusGreen {...(!canEdit ? { className: classes.grayedAddSvg } : {})} /><Typography ml="8px" fontSize={18} fontWeight="500" lineHeight="26.91px" color={canEdit ? "#5DA196" : "#A0A0A0"}>{t('competencyMapping.add')}</Typography>
                                            </Box>
                                        </Button>
                                    </Box>
                                    <Box>
                                        <Box px="20px" sx={{ background: "#FAFAFA", height: "50px", borderTop: "1px solid #E5E5E5", borderBottom: "1px solid #E5E5E5", display: "flex", alignItems: "center" }}>
                                            <Box sx={{ width: "calc(14% - 18.75px)" }} pr="20px">
                                                <Typography color="#A0A0A0" fontSize={14} lineHeight="20.93px" fontWeight="500" >{t('competencyMapping.code')}</Typography>
                                            </Box>
                                            <Box sx={{ width: "calc(26% - 18.75px)" }} pr="35px">
                                                <Typography color="#A0A0A0" fontSize={14} lineHeight="20.93px" fontWeight="500" >{t('competency.name')}</Typography>
                                            </Box>
                                            <Box sx={{ width: "calc(30% - 18.75px)" }} pr="35px">
                                                <Typography color="#A0A0A0" fontSize={14} lineHeight="20.93px" fontWeight="500" >{t('competencyMapping.proficiencyLevel')} <span style={{ color: "#CC6058" }}>*</span></Typography>
                                            </Box>
                                            <Box sx={{ width: "calc(30% - 18.75px)" }} pr="35px">
                                                <Typography color="#A0A0A0" fontSize={14} lineHeight="20.93px" fontWeight="500" >{t('competencyMapping.expectedRating')} <span style={{ color: "#CC6058" }}>*</span></Typography>
                                            </Box>
                                            <Box sx={{ width: "75px", textAlign: "center" }}>
                                                <Typography color="#A0A0A0" fontSize={14} lineHeight="20.93px" fontWeight="500" >{t('label.titleForm.action')}</Typography>
                                            </Box>
                                        </Box>
                                        {Util.formatData(itemsCompetency, false) !== false && itemsCompetency.length > 0 ? itemsCompetency.map((rs, index) => (
                                            <Box >
                                                <Box>
                                                    <Box px="20px" sx={{ height: "50px", borderBottom: "1px solid #E5E5E5", display: "flex", alignItems: "center" }}
                                                        // onClick={(event) => handleClick(event, data.serial)}
                                                        role="checkbox"
                                                        key={index}
                                                    >
                                                        <Box sx={{ background: "#F5F5F5", borderRadius: "2px", height: "25px", width: "25px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }} onClick={(e) => onChangeOpen(rs?.serial)}>
                                                            {itemsOpen.filter((res) => res === rs?.serial).length > 0 ? <ExpandUp /> : <ExpandDown />}
                                                        </Box>
                                                        <Typography pl="20px" color="#5DA196" fontSize={16} lineHeight="23.92px" fontWeight="600" >{rs?.name}</Typography>
                                                    </Box>
                                                </Box>
                                                <Collapse in={itemsOpen.filter((res) => res === rs?.serial).length > 0}>
                                                    <Box>
                                                        {Util.formatData(rs?.competencies, false) !== false && rs?.competencies.length > 0 ? rs?.competencies.map((res, id) => (
                                                            <Box px="20px" py="9px" sx={{ borderBottom: "1px solid #E5E5E5", display: "flex", }} key={id}>
                                                                <Box sx={{ width: "calc(14% - 18.75px)" }} pr="20px">
                                                                    <Typography mt="4px" color="#404349" fontSize={16} lineHeight="23.92px" fontWeight="400" >{res?.code}</Typography>
                                                                </Box>
                                                                <Box sx={{ width: "calc(26% - 18.75px)" }} pr="35px">
                                                                    <Typography mt="4px" color="#404349" fontSize={16} lineHeight="23.92px" fontWeight="400" >{res?.name}</Typography>
                                                                </Box>
                                                                <Box sx={{ width: "calc(30% - 18.75px)" }} pr="35px">
                                                                    <Box sx={{ ".MuiOutlinedInput-root": { color: "#404349", padding: "4px 14px", ".MuiInputBase-input": { padding: "0" } } }}>
                                                                        {/* <Box sx={{ padding: "0 41px", ".MuiOutlinedInput-root": { color: "#404349", "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#5DA196" } } },".MuiOutlinedInput-root.Mui-error": { "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#CC6058" } } } }}> */}
                                                                        {res?.have_proficiency && res?.proficiency?.length > 0 ?
                                                                            <Select
                                                                                id="workload-select"
                                                                                inputlabelprops={{ shrink: false }}
                                                                                variant="outlined"
                                                                                size="small"
                                                                                error={submit && Util.formatData(formik.values.competency_mapping_data[res.serial]?.expected_rating, false) === false ? true : false}
                                                                                fullWidth
                                                                                // helperText={formik.touched.permission_group && formik.errors.permission_group}
                                                                                name="permission_group"
                                                                                defaultValue=""
                                                                                displayEmpty
                                                                                className="white-bg"
                                                                                disabled={canEdit === false ? true : false}
                                                                                MenuProps={{ autoFocus: false, sx: { ".MuiPaper-root": { maxWidth: "21.2% !important", minWidth: "21.2% !important" } } }}
                                                                                // onBlur={formik.handleBlur}
                                                                                value={formik.values.competency_mapping_data[res.serial]?.proficiency_id !== undefined ? formik.values.competency_mapping_data[res.serial]?.proficiency_id : ""}
                                                                                // onChange={formik.handleChange}
                                                                                classes={{ root: canEdit === false ? classes.disabled : {} }}
                                                                            >
                                                                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                                                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t('competencyMapping.selectProficiency')} </Typography>
                                                                                </MenuItem>
                                                                                {
                                                                                    res?.proficiency.map(item => {
                                                                                        return (
                                                                                            <MenuItem value={item.serial} key={item.serial} onClick={e => selectValuse(res.serial, item.serial, formik.values.competency_mapping_data, 'proficiency_id')}>
                                                                                                <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px", overflow: "hidden", "text-overflow": "ellipsis", }}>{t('competency.level')} {item?.level} - {getName(item?.description)}</span>
                                                                                            </MenuItem>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                            :
                                                                            null
                                                                        }
                                                                        {res?.have_proficiency && res?.proficiency?.length > 0 && submit && Util.formatData(formik.values.competency_mapping_data[res.serial]?.expected_rating, false) === false ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('label.pleaseFillOutThisField')}</FormHelperText>) : <></>}
                                                                    </Box>
                                                                </Box>
                                                                <Box sx={{ width: "calc(30% - 18.75px)", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }} pr="35px">
                                                                    <Box sx={{ ".MuiOutlinedInput-root": { color: "#404349", padding: "4px 14px", ".MuiInputBase-input": { padding: "0" } } }}>
                                                                        {/* <Box sx={{ padding: "0 41px", ".MuiOutlinedInput-root": { color: "#404349", "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#5DA196" } } },".MuiOutlinedInput-root.Mui-error": { "&:hover": { ".MuiOutlinedInput-notchedOutline": { borderColor: "#CC6058" } } } }}> */}
                                                                        {res?.competency_scale?.length > 0 ?
                                                                            <Select
                                                                                id="workload-select"
                                                                                inputlabelprops={{ shrink: false }}
                                                                                variant="outlined"
                                                                                size="small"
                                                                                error={submit && Util.formatData(formik.values.competency_mapping_data[res.serial]?.expected_rating, false) === false ? true : false}
                                                                                fullWidth
                                                                                // helperText={formik.touched.permission_group && formik.errors.permission_group}
                                                                                name="permission_group"
                                                                                defaultValue=""
                                                                                displayEmpty
                                                                                className="white-bg"
                                                                                disabled={canEdit === false ? true : false}
                                                                                classes={{ root: canEdit === false ? classes.disabled : {} }}
                                                                                MenuProps={{ autoFocus: false, sx: { ".MuiPaper-root": { maxWidth: "21.2% !important", minWidth: "21.2% !important" } } }}
                                                                                // onBlur={formik.handleBlur}
                                                                                value={formik.values.competency_mapping_data[res.serial]?.expected_rating !== undefined ? formik.values.competency_mapping_data[res.serial]?.expected_rating : ""}
                                                                            // onChange={formik.handleChange}
                                                                            >
                                                                                <MenuItem disabled value="" sx={{ display: "none" }}>
                                                                                    <Typography variant="sub_label" style={{ fontSize: "16px", fontWeight: "300", lineHeight: "23.92px", color: "#AAAAAA" }}>{t('competencyMapping.selectExpectedRating')} </Typography>
                                                                                </MenuItem>
                                                                                {
                                                                                    res?.competency_scale.map(item => {
                                                                                        return (
                                                                                            res?.have_proficiency === true ?
                                                                                                Util.formatData(formik.values.competency_mapping_data[res.serial]?.proficiency_id, false) !== false && formik.values.competency_mapping_data[res.serial]?.proficiency_id === item?.options?.proficiency ?
                                                                                                    <MenuItem value={item.serial} key={item.serial} onClick={e => selectValuse(res.serial, item.serial, formik.values.competency_mapping_data, 'expected_rating')} >
                                                                                                        <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px", overflow: "hidden", "text-overflow": "ellipsis", }}>{item?.level} - {getName(item?.description)}</span>
                                                                                                    </MenuItem>
                                                                                                    :
                                                                                                    null
                                                                                                :
                                                                                                <MenuItem value={item.serial} key={item.serial} onClick={e => selectValuse(res.serial, item.serial, formik.values.competency_mapping_data, 'expected_rating')} >
                                                                                                    <span style={{ color: "#404349", fontSize: "16px", fontWeight: "400", lineHeight: "23.92px", overflow: "hidden", "text-overflow": "ellipsis", }}>{item?.level} - {getName(item?.description)}</span>
                                                                                                </MenuItem>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </Select>
                                                                            :
                                                                            null
                                                                        }
                                                                        {res?.competency_scale?.length > 0 && submit && Util.formatData(formik.values.competency_mapping_data[res.serial]?.expected_rating, false) === false ? (<FormHelperText error sx={{ marginTop: "3px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('label.pleaseFillOutThisField')}</FormHelperText>) : <></>}
                                                                    </Box>
                                                                </Box>
                                                                <Box sx={{ width: "75px" }} >
                                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} mt="6px">
                                                                        <EyeMapping style={{ marginRight: canEdit === false ? "0" : "20px", cursor: "pointer" }} onClick={() => { openNewTab(`/admin/competency-mapping/competency-item/${cycle_id}/${Util.formatData(res?.category_subgroup?.serial, res?.category_group?.serial)}/${res?.serial}`) }} />
                                                                        {canEdit === false ?
                                                                            null
                                                                            :
                                                                            <Trash style={{ cursor: "pointer" }} onClick={e => handleConfirmDeleteDialog(true, res.serial, formik.values.competency_mapping_data, index, id)} />
                                                                        }
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        ))
                                                            : null}
                                                    </Box>
                                                </Collapse>
                                            </Box>))
                                            :
                                            <Box sx={{ "padding-top": "36px", "text-align": "center", "padding-bottom": "40px" }}>
                                                <img src={emty} alt="emtyData" style={{ height: "82px" }}></img>
                                                <Typography pt="3px" fontSize={14} lineHeight="20.93px" fontWeight="300" color="#939393">{t('competencyMapping.noCompetency')}</Typography>
                                                {canEdit && <Typography fontSize={14} lineHeight="20.93px" fontWeight="500" color="#5DA196" onClick={canEdit === true ? openAdd : null} sx={{ textDecorationLine: 'underline', cursor: "pointer" }}>{t('competencyMapping.clickHereToAddCompentency')}</Typography>}
                                            </Box>
                                        }

                                    </Box>

                                </Box>
                                <Box container mt="30px" >
                                    <Box item xs display="flex" flexDirection="row-reverse">
                                        <Box sx={{ width: "100px" }}>
                                            <Button onClick={formik.submitForm} disabled={canEdit === true ? firstChange === true ? false : true : true} color="primary" variant="contained" fullWidth sx={{ textTransform: "none" }}>
                                                <Typography fontSize={18} lineHeight="29px" fontWeight="500" color="#FFF">{t('competencyMapping.save')}</Typography>
                                            </Button>
                                        </Box>
                                        <Box mr={2} sx={{ width: "100px" }}>
                                            <Button color="black" onClick={e => handleConfirm(true)} variant="outlined" fullWidth sx={{ textTransform: "none" }}>
                                                <Typography fontSize={18} lineHeight="29px" fontWeight="500" color="#6B6B6B"> {t('competencyMapping.cancel')}</Typography>
                                            </Button>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                    <AddCompetency open={open} itemsAdd={itemsAdd} itemsCompetency={itemsCompetency} next={nextData} close={e => setOpen(false)} />
                    <DialogSubTitle
                        open={isSuccessDeleteDialogOpen}
                        setValue={saveSuccess}
                        text={`${t('competencyMapping.competencyMappingFor')} <br/> ${target?.name} ${t('competencyMapping.successfully')}`}
                    />
                    <ConfirmDialog
                        open={isConfirmDeleteDialogOpen}
                        doConfirm={handleConfirmDeleteList}
                        setValue={handleConfirmDeleteDialog}
                        title={t('label.confirmationofDeletion')}
                        text={t('competencyMapping.deleteCompetency')}
                    />
                    <ConfirmDialog
                        warning={true}
                        open={isConfirmOpen}
                        doConfirm={handleConfirmChange}
                        setValue={handleConfirm}
                        title={t('label.confirmationOfDiscard')}
                        text={t('label.youSureDiscardChange')}
                    />
                </Container>
            </Box>
        </Box >
    );
};
export default Cycle;
